import React, { FC, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { IconContext } from 'react-icons'
import { BsFillPencilFill, BsXSquareFill } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
/* import DTOOpViajes from '../../../DTOs/Operaciones/DTOViajes'
import DTOViajesServicios from '../../../DTOs/Operaciones/DTOViajesServicios' */
import { RootState } from '../../../../store/store'
import DSOpViajes from '../../../../Services/Operaciones/OpViajes.Services'
import { deleteOpViajesServicios } from '../../../../store/features/Operaciones/OpViajesServiciosSlice'
import DTOViajesServicios from '../../../../DTOs/Operaciones/DTOViajesServicios'

interface IProps {
  IDMaster: number
  actionButtons: boolean
  onLoadDetail: (id: number) => void
}

export const Servicios: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const mAllTripServices = useSelector((state: RootState) => state.OpViajesServicios.OpViajesServicios)
  const mAduanas = useSelector((state: RootState) => state.CatAduanas.CatAduanas)
  const [DisplayTable, setDisplayTable] = useState(true)

  const deleteService = (id: number) => {
    DSOpViajes.DeleteService(id)
      .then((responsed) => {
        dispatch(deleteOpViajesServicios(id))
      })
      .catch((e: Error) => {})
  }

  const getAduana = (id: number) => {
    let found = mAduanas.filter((a) => {
      if (a.id === id) {
        return a
      }
    })
    //  console.log(found)
    if (found.length) {
      if (found[0].Aduana === 'Aduana') return ''
      else return found[0].Aduana
    }
    return ''
  }

  const editService = (service: DTOViajesServicios) => {}

  return (
    <div>
      <table className='zui-table zui-table-rounded'>
        <thead>
          <tr>
            {/* <th style={{ width: '50px', textAlign: 'center' }}>id</th> */}
            {props.actionButtons ? (
              <>
                <th style={{ width: '30px', textAlign: 'center' }}></th>
              </>
            ) : (
              ''
            )}
            <th style={{ width: '20%', textAlign: 'left' }}>Servicio</th>
            <th style={{ width: '10%', textAlign: 'left' }}>Caja</th>
            <th style={{ width: '10%', textAlign: 'left' }}>Aduana</th>
            <th style={{ width: '10%', textAlign: 'left' }}>Cita</th>
            <th style={{ width: '20%', textAlign: 'left' }}>Proveedor</th>
            <th style={{ width: '20%', textAlign: 'left' }}>Comentarios</th>
            {props.actionButtons ? (
              <>
                <th style={{ width: '30px', textAlign: 'center' }}></th>
              </>
            ) : (
              ''
            )}
          </tr>
        </thead>
        <tbody>
          {mAllTripServices
            ? mAllTripServices
                .filter(function (service) {
                  return service.idViaje === props.IDMaster
                })
                .map(function (service) {
                  return (
                    <tr key={service.id} style={{ height: '30px' }}>
                      {/* <td style={{ textAlign: 'left', paddingLeft: '5px' }}>{service.id}</td> */}
                      {props.actionButtons ? (
                        <>
                          <td>
                            <Button
                              size='sm'
                              variant='white'
                              style={{ textAlign: 'right' }}
                              title='De un click aqui para eliminar el servicio'
                              onClick={() => {
                                deleteService(service.id)
                              }}
                            >
                              <IconContext.Provider value={{ color: 'red', size: '20px' }}>
                                <BsXSquareFill />
                              </IconContext.Provider>
                            </Button>
                          </td>
                        </>
                      ) : (
                        ''
                      )}
                      <td style={{ textAlign: 'left' }}>{service.sServicio}</td>
                      <td style={{ textAlign: 'left' }}>{service.noCaja}</td>
                      <td style={{ textAlign: 'left' }}>{getAduana(service.aduana)}</td>
                      <td style={{ textAlign: 'left' }}>{service.cita?.includes('1900') ? '' : service.cita}</td>
                      <td style={{ textAlign: 'left' }}>{service.sProveedor}</td>
                      <td style={{ textAlign: 'left' }}>{service.comentarios}</td>
                      {props.actionButtons ? (
                        <>
                          <td style={{ textAlign: 'right', paddingRight: '20px' }}>
                            <Button
                              size='sm'
                              variant='white'
                              style={{ textAlign: 'right' }}
                              onClick={() => {
                                props.onLoadDetail(service.id)
                              }}
                            >
                              <IconContext.Provider value={{ color: 'blue', size: '15px' }}>
                                <BsFillPencilFill />
                              </IconContext.Provider>
                            </Button>
                          </td>
                        </>
                      ) : (
                        ''
                      )}
                    </tr>
                  )
                })
            : ''}
        </tbody>
      </table>
    </div>
  )
}
